export const CONSENT_MESSAGES = [
  {
    messageKey: 'phoneConsentCustomerServiceAndSupportCheckboxLabel',
  },
];
